import { createFileRoute } from '@tanstack/react-router'
// The SCHEMA is what this page needs: it is the public report form's validator, and this route IS that
// form. It ships zod either way, so importing the schema through the barrel costs it nothing extra — it is
// on FORM_ROUTES in vite.config.ts for the same reason.
// oxlint-disable-next-line shared-barrel/no-barrel-values -- this route is the form; see above.
import { publicReportFormSchema, type PublicReportForm } from 'shared'
import { useAppForm } from '@/lib/use-app-form'
import { AuthPending } from './-components/app-layout-skeleton'
import { ButtonPrimitive } from '@/components/ui/button-primitive'

export const Route = createFileRoute('/_app/beta/generate')({
  component: RouteComponent,
  pendingComponent: AuthPending,
})

function RouteComponent() {
  // Annotated (not inferred) so `name` stays an OPTIONAL key, matching the schema: zod 4.4 treats a
  // property that merely accepts `undefined` as required, so the schema uses `.optional()` and an
  // inferred-from-literal defaultValues would make the key required and fail to match the validator.
  const defaultValues: PublicReportForm = { name: '', answers: '' }

  const form = useAppForm({
    validators: { onChange: publicReportFormSchema },
    defaultValues,
    onSubmit: ({ value }) => {
      window
        .open(
          `/beta/report?${new URLSearchParams({
            profiles: JSON.stringify({
              first: {
                type: 'public',
                name: value.name,
                ...JSON.parse(value.answers),
              },
              selected: 'first',
              type: 'competences',
            }),
          })}`,
          '_blank',
        )
        ?.focus()
    },
  })
  return (
    <form
      onSubmit={(event) => {
        event.preventDefault()
        form.handleSubmit()
      }}
      className="mx-auto flex max-w-96 flex-col gap-4 p-6"
    >
      <form.AppField name="name" children={(field) => <field.TextField label="name" />} />
      <form.AppField name="answers" children={(field) => <field.TextField label="answers" />} />
      <ButtonPrimitive type="submit">generate</ButtonPrimitive>
    </form>
  )
}
